import { createFileRoute } from "@tanstack/react-router";
import { Showcase } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/showcase")({
  head: () => seoHead({
    title: "Showcase — Kids' Drawings & Stories",
    description:
      "A wall of creativity, courage and kindness — drawings and handwritten articles shared by children learning with LeadXkids.",
    canonical: "/showcase",
  }),
  component: Showcase,
});
